import {useTranslation} from "next-i18next";

/**
 *
 */
type Licence = {
    name ?: string,
    url : string
};

/**
 *
 */
export type SourceData = {
    description ?: string
    url : string
    name ?: string
    licence ?: Licence
};

/**
 *
 * @param description
 * @param url
 * @param name
 * @param licence
 * @constructor
 */
export default function Source ({ description, url, name, licence } : SourceData) {
    // init
    const { t } = useTranslation();

    // render
    return (
        <>
            <p className={'mb-1 font-weight-lighter small fst-italic text-muted'}>
                {description ? <span>{description}: </span> : ''}
                {url ? (<a href={url} target={'_blank'} rel={'noopener noreferrer nofollow'}>{name ? name : url}</a>) : (<span>{name}</span>)}
                {licence ? (<span> {t('under.the')} </span>) : ''}
                {licence ? (<a href={licence.url} target={'_blank'} rel={'noopener noreferrer nofollow'}>{licence.name ? licence.name : licence.url}</a>) : ''}
            </p>
        </>
    )
}